import type { QueryParam } from '../indexedDB/disasterOperationDisastersIdb'
import { queryBuildingDaoApi } from './requests/disasterCommonBuildingApiGwFuncs'
import type { ApiConnector } from '@/types/accessor/common/connector'

export const query: ApiConnector = async (param, indexedDBConnector) => {
  const data = await queryBuildingDaoApi(param as QueryParam)
  await indexedDBConnector(data)
  return data
}
